import { Injectable } from '@angular/core';
import { Base64ToBlobService } from './base64-to-blob.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadLocalFileService {

  constructor( private base64ToBlobService: Base64ToBlobService ) { }

  downLoadFile( base64File: string, name: string, extension: string ) {
   
    const fileName =  name + '.' + extension;
    console.log(fileName);
    const blob = this.base64ToBlobService
      .base64toBlob(base64File, `application/${ extension }`);
    const downloadURL =  window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadURL;
    link.setAttribute("download", fileName);
    link.click();
  }

}
